import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate , useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { getDate, getItemFromStorage, setItemToStorage, userPicUrl } from "../../utils/Helper";
import { CustomerDetailsAction } from "../../Redux/Action/CustomerAction";
import { decodeID  , getLastURL } from "../../utils/Helper";
import { useIntl, FormattedMessage } from 'react-intl';




function CustomerView() {
    const intl = useIntl();
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const log_in = useSelector((state: any) => state.CustomerDetailsState)
    const customerdata = useSelector((state: any) => state.CustomerDetailsState?.data?.data?.detail)
    const location = useLocation();
    const editId = getLastURL(location);
    const [loading  , setLoading] = useState(false)
    
    const handleBack = () => {
        setItemToStorage('customerdata', '')
        navigate('/customer-management-list')
    }
    useEffect(()=>{
        setLoading(true)
        var params = {
            detail_id: decodeID(editId)
        };
     dispatch(CustomerDetailsAction(params))
     setTimeout(() => {
        setLoading(false)
      }, 400);
    },[])

    let totalbooking = customerdata?.booking_details?.length
    let totalpending = customerdata?.booking_details.filter((res:any)=> res.status == "0")
    let totalcomeplete = customerdata?.booking_details.filter((res:any)=> res.status == "1")
    let totalcancel = customerdata?.booking_details.filter((res:any)=> res.status == "2")
    let totalNoshownup = customerdata?.booking_details.filter((res:any)=> res.status == "3")

    return (
        <Fragment>
            { loading ||  log_in?.loading ? <Spinner /> : ""}
            <PageLayout
                title={intl.formatMessage({ id: 'customer_management' })}
                breadcrumbs={{
                    secLast: { 'link': '/customer-management-list', 'name': intl.formatMessage({ id: 'customer_management' }) },
                }}
                buttons={[
                    { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
                ]}
            >
                <div className="card">
                    <div className="card-body">
                        <div className="row gy-4">
                        <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="customer_profile_picture" />:</label>
                                    </div>
                                    <div className="col-md-9">
                                       <img src={userPicUrl(customerdata?.profile_pic)} alt="image" width={70} height={70} style={{borderRadius:"35px"}} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="customer_id" />:</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.id ? customerdata?.id : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="name" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.name ? customerdata?.name : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="mobile" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata ? `${customerdata?.phone_country_code || '--'}  ${customerdata.phone_number || '--'}` : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="gender" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.gender ? customerdata?.gender : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="email" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.email ? customerdata?.email : '--'}</span>
                                    </div>
                                </div>
                            </div>
                             <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="dob" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.dob ? customerdata?.dob : '--'}</span>
                                    </div>
                                </div>
                            </div> 
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="country" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.country == "null" ? "---" : customerdata?.country ? customerdata.country : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="bio" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.bio == "null" ? "--" : customerdata?.bio ? customerdata?.bio : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="status" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.status == "1" ? intl.formatMessage({ id: 'active' }) : intl.formatMessage({ id: 'inactive' })}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="registration_date" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.created_at ? getDate(customerdata?.created_at) : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="total_number_of_bookings" /></label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalbooking}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="completed_bookings" /></label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalcomeplete?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="cancelled_bookings" /></label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalcancel?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="upcoming_bookings" /></label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalpending?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="no_shows_bookings" /></label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalNoshownup?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} ><FormattedMessage id="back" /></button>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default CustomerView;